<template>
    <div
        class="lm-border v-flex"
        :class="dense ? 'column-header-dense' : 'column-header'"
        style="border-radius: 4px; "
        :style="titleBorder ? 'border-bottom-left-radius: 0!important; border-bottom-right-radius: 0!important;margin-top: -1px; width: calc(100% + 2px); margin-left: -1px;' :'' + ' height:'"
    >
        <div
            class=" primary--text pl-0 v-flex w-100"
            :class="dense ? 'column-text-dense' : 'column-text'"
        >
            <div class=" white--text pl-2 v-flex " style="margin-top: -1px">
                <slot name="pre"></slot>
                {{ label }}
                <slot name="post"></slot>
            </div>

            <v-spacer />
            <slot name="toolbar"></slot>
            <slot name="filter"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "CColumnHeader",

    props: {
        label: {

        },

        titleBorder: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        dense: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
    },

    data: () => ({
        sites: false
    }),

    computed: {

    }
}
</script>

<style scoped>

.column-header {
    height: 30px;
    line-height: 30px;
}

.column-text {
    font-weight: 500;
    font-size: 16px
}

.column-header-dense {
    height: 25px;
    line-height: 25px;
}

.column-text-dense {
    font-weight: 500;
    font-size: 14px
}

</style>